import { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { signal, computed, effect } from '@preact/signals-react';
import '../Toast/styles/Toast.css';
import { notificationStyles } from './config/generalConf';
import { GrFormClose } from 'react-icons/gr';
import { notificationsAfterLogin, notificationsBeforeLogin } from './notifications';

const ToastNotificationInstance: FC<{}> = () => {
  const progressRef = useRef<any>(null);
  const timerID = useRef<any>(null);
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = () => {
    setDismissed(true);
    if (notificationsAfterLogin.value.length == 0) {
      return;
    } else if (notificationsBeforeLogin.value.length == 0) {
      return;
    }
    setTimeout(() => {
      notificationsAfterLogin.value = [];
      notificationsBeforeLogin.value = [];
    }, 4000);
  };

  useEffect(() => {
    timerID.current = setTimeout(() => {
      handleDismiss();
    }, 4000);

    return () => {
      clearTimeout(timerID.current);
    };
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timerID.current);
    progressRef.current.style.animationPlayState = 'paused';
  };

  const handleMouseLeave = () => {
    const remainingTime = (progressRef.current.offsetWidth / progressRef.current.parentElement.offsetWidth) * 4000;

    progressRef.current.style.animationPlayState = 'running';

    timerID.current = setTimeout(() => {
      handleDismiss();
    }, remainingTime);
  };

  console.log('notificationsAfterLogin', notificationsAfterLogin.value)

  return (
    <div className="toasts-container top-right">
      {notificationsBeforeLogin.value.length > 0 &&
        notificationsBeforeLogin.value.map((notification: any, index: any) => (
          <div className={`toast ${dismissed ? 'toast-dismissed' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <span className={`${notificationStyles[notification?.type?.toUpperCase()]?.textColor}`}>{notificationStyles[notification?.type?.toUpperCase()]?.icon}</span>
            <p className="toast-message">{notification.message}</p>
            <button className="dismiss-btn" onClick={handleDismiss}>
              <GrFormClose size={14} />
            </button>

            {/* Toast Progress Bar */}
            <div className="toast-progress">
              <div ref={progressRef} className={`toast-progress-bar ${notificationStyles[notification?.type?.toUpperCase()]?.bgColor}`}></div>
            </div>
          </div>
        ))}

      {notificationsAfterLogin.value.length > 0 &&
        notificationsAfterLogin.value.map((notification: any, index: any) => (
          <div className={`toast ${dismissed ? 'toast-dismissed' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <span className={`${notificationStyles[notification?.type?.toUpperCase()]?.textColor}`}>{notificationStyles[notification?.type?.toUpperCase()]?.icon}</span>
            <p className="toast-message">{notification.message}</p>
            <button className="dismiss-btn" onClick={handleDismiss}>
              <GrFormClose size={14} />
            </button>

            {/* Toast Progress Bar */}
            <div className="toast-progress">
              <div ref={progressRef} className={`toast-progress-bar ${notificationStyles[notification?.type?.toUpperCase()]?.bgColor}`}></div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ToastNotificationInstance;
